<template>
  <v-card class="main-card content">
    <v-card-title class="screen-title">
      <span>設定上限値</span>
      <manual-button path="/nwinfo-limit/" />
    </v-card-title>
    <v-card-text v-if="isLoaded">
      <v-row
        ><v-col>
          <validation-observer v-slot="{ handleSubmit }" as="div">
            <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
              <app-badge
                item="上限値項目"
                :is-required="false"
                :isInfo="false"
              />
              <app-multi-select
                v-model="selectedUnit"
                :options="displayUnits"
                track-by="unit"
                :multiple="false"
                :custom-label="labelUnit"
              >
                <template #beforeList>
                  <div class="multiselect-thead">
                    <p>管理単位</p>
                    <p>回線番号</p>
                    <p>詳細項目</p>
                  </div>
                </template>
                <template #option="{ option }">
                  <div class="multiselect-tbody">
                    <p>{{ option.l1 }}</p>
                    <p>{{ $filter.emptyTo(option.l2, "-") }}</p>
                    <p>{{ $filter.emptyTo(option.l3, "-") }}</p>
                  </div>
                </template>
              </app-multi-select>

              <template v-if="selectedUnit">
                <!-- 契約 - V番号 -->
                <template
                  v-if="
                    selectedUnit.unit === 'CONTRACT_NUMBER' && upperLimit1.items
                  "
                >
                  <app-table
                    primary-key="upperLimitItemName"
                    :bordered="true"
                    :fields="upperLimit1.fields"
                    :items="upperLimit1.items"
                    :per-page="-1"
                    :no-data-text="$filter.message('no_data')"
                    :tr-class="() => undefined"
                  >
                    <template #cell(current)="{ item }">
                      <template v-if="item.current === null">-</template>
                      <template v-else
                        >{{ item.current }} {{ item.unit }}</template
                      >
                    </template>
                    <template #cell(upperLimit)="{ item }">
                      <template
                        v-if="
                          item.upperLimitItemName ===
                            'AWS(ホスト型接続)合計帯域' &&
                          item.upperLimit >= 1000 &&
                          item.unit === 'Mbps'
                        "
                      >
                        {{ item.upperLimit / 1000 }} Gbps
                      </template>
                      <template v-else>
                        {{ item.upperLimit }} {{ item.unit }}
                      </template>
                    </template>
                  </app-table>
                </template>
                <!-- その他 -->
                <template v-if="upperLimitSearch">
                  <app-badge
                    item="回線番号"
                    :is-required="false"
                    :isInfo="false"
                  />
                  <validation-provider
                    name="selectedLineNumbers"
                    label="回線番号"
                    v-model="selectedLineNumbers"
                    :rules="{ required: true }"
                    v-slot="{ componentField, errorMessage }"
                  >
                    <app-multi-select
                      v-bind="componentField"
                      :options="
                        lineNumberOptions[0].values.length === 0
                          ? []
                          : lineNumberOptions
                      "
                      :multiple="true"
                      group-label="labels"
                      group-values="values"
                      :custom-label="labelLineNumber"
                      track-by="index"
                      :max="5"
                      :error-messages="errorMessage"
                    >
                      <template #tag="{ option, remove }">
                        <multi-select-tag
                          :option="option"
                          :remove="remove"
                          class="w-50"
                        >
                          <v-row>
                            <v-col>{{ option.label1 }}</v-col>
                            <v-col v-if="option.label2">{{
                              option.label2
                            }}</v-col>
                            <v-col v-if="option.label3">{{
                              option.label3
                            }}</v-col>
                          </v-row>
                        </multi-select-tag>
                      </template>
                      <template #option="{ option }">
                        <div
                          v-if="option.$groupLabel"
                          class="d-flex font-weight-bold"
                        >
                          <v-col class="pa-0">
                            {{ option.$groupLabel.item1 }}
                          </v-col>
                          <v-col v-if="option.$groupLabel.item2" class="pa-0">
                            {{ option.$groupLabel.item2 }}
                          </v-col>
                          <v-col v-if="option.$groupLabel.item3" class="pa-0">
                            {{ option.$groupLabel.item3 }}
                          </v-col>
                        </div>
                        <div v-else class="multiselect-tbody">
                          <v-col class="pa-0">{{ option.label1 }}</v-col>
                          <v-col class="pa-0" v-if="option.label2">{{
                            option.label2
                          }}</v-col>
                          <v-col class="pa-0" v-if="option.label3">{{
                            option.label3
                          }}</v-col>
                        </div>
                      </template>
                    </app-multi-select>
                  </validation-provider>
                  <div class="d-flex justify-end mr-2 ga-2">
                    <v-btn
                      color="primary"
                      variant="outlined"
                      class="mr-3"
                      @click="reset"
                      >リセット</v-btn
                    >
                    <v-btn color="primary" type="submit">上限値表示</v-btn>
                  </div>
                </template>

                <v-table
                  v-if="upperLimit2.items"
                  class="table mt-3 table-bordered"
                  :items-per-page="3"
                >
                  <thead>
                    <tr>
                      <th class="text-center font-weight-bold">回線番号</th>
                      <th class="text-center font-weight-bold">設定項目</th>
                      <th class="text-center font-weight-bold">現在設定数</th>
                      <th class="text-center font-weight-bold">上限値</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(e, i1) in upperLimit2.items" :key="i1">
                      <!-- アクセス回線 -->
                      <template
                        v-if="
                          selectedUnit.unit === 'ACCESS_NUMBER' ||
                          selectedUnit.unit === 'ACCESS_NUMBER_VLAN'
                        "
                      >
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.accessLine &&
                            e.accessLine.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{ e.accessLine.enumber }}<br />
                              <template
                                v-if="e.accessLine.vlanIdType === 'SPECIFIED'"
                              >
                                VLAN: {{ e.accessLine.vlanId }}
                              </template>
                              <template v-else>
                                VLAN:
                                {{
                                  $filter.enumTo(
                                    e.accessLine.vlanIdType,
                                    "vlanIdType"
                                  )
                                }}
                              </template>
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.accessLine &&
                            e.accessLine.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.accessLine.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 === e.accessLine.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.accessLine.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{ e.accessLine.enumber }}<br />
                                <template
                                  v-if="e.accessLine.vlanIdType === 'SPECIFIED'"
                                >
                                  VLAN: {{ e.accessLine.vlanId }}
                                </template>
                                <template v-else>
                                  VLAN:
                                  {{
                                    $filter.enumTo(
                                      e.accessLine.vlanIdType,
                                      "vlanIdType"
                                    )
                                  }}
                                </template>
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- アプライアンス（インターネット回線） -->
                      <template
                        v-if="
                          selectedUnit.unit === 'APPLIANCE_PF' ||
                          selectedUnit.unit === 'APPLIANCE_INTRANET' ||
                          selectedUnit.unit === 'APPLIANCE_NUMBER_INTERNET' ||
                          selectedUnit.unit === 'APPLIANCE_NUMBER_UTM' ||
                          selectedUnit.unit === 'APPLIANCE_NUMBER_NAT' ||
                          selectedUnit.unit === 'INTERNET4_NUMBER'
                        "
                      >
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.internetLine &&
                            e.internetLine.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              <template v-if="e.internetLine.type1">
                                {{ e.internetLine.type1.enumberMainAct }}<br />
                                {{ e.internetLine.type1.enumberMainSby }}
                              </template>
                              <template v-else-if="e.internetLine.type4">
                                {{ e.internetLine.type4.wnumberMainAct }}<br />
                                {{ e.internetLine.type4.wnumberMainSby }}
                              </template>
                              <!-- インターネットType4の場合は非表示 -->
                              <template
                                v-if="selectedUnit.unit !== 'INTERNET4_NUMBER'"
                              >
                                <p class="pa-0 ma-0">
                                  {{
                                    $filter.enumTo(
                                      e.internetLine.applianceType,
                                      "upperLimit_applianceType"
                                    )
                                  }}
                                </p>
                              </template>
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.internetLine &&
                            e.internetLine.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.internetLine.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 ===
                                  e.internetLine.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.internetLine.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                <template v-if="e.internetLine.type1">
                                  {{ e.internetLine.type1.enumberMainAct
                                  }}<br />
                                  {{ e.internetLine.type1.enumberMainSby }}
                                </template>
                                <template v-else-if="e.internetLine.type4">
                                  {{ e.internetLine.type4.wnumberMainAct
                                  }}<br />
                                  {{ e.internetLine.type4.wnumberMainSby }}
                                </template>
                                <!-- インターネットType4の場合は非表示 -->
                                <template
                                  v-if="
                                    selectedUnit.unit !== 'INTERNET4_NUMBER'
                                  "
                                >
                                  <p class="pa-0 ma-0">
                                    {{
                                      $filter.enumTo(
                                        e.internetLine.applianceType,
                                        "upperLimit_applianceType"
                                      )
                                    }}
                                  </p>
                                </template>
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- PFGW(イントラ) -->
                      <template v-if="selectedUnit.unit === 'PFGW_NUMBER'">
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.pfgwLine && e.pfgwLine.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{ e.pfgwLine.enumberAct }}<br />
                              {{ e.pfgwLine.enumberSby }}<br />
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.pfgwLine && e.pfgwLine.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.pfgwLine.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 === e.pfgwLine.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.pfgwLine.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{ e.pfgwLine.enumberAct }}<br />
                                {{ e.pfgwLine.enumberSby }}<br />
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- VNコネクト -->
                      <template v-if="selectedUnit.unit === 'VN_NUMBER'">
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.vnConnect &&
                            e.vnConnect.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{ e.vnConnect.wnumber }}
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>

                        <template
                          v-if="
                            e.vnConnect &&
                            e.vnConnect.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.vnConnect.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 === e.vnConnect.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.vnConnect.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{ e.vnConnect.wnumber }}
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- VN L2L3コネクト -->
                      <template v-if="selectedUnit.unit === 'VNL2L3_NUMBER'">
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.vnl2l3Line &&
                            e.vnl2l3Line.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{ e.vnl2l3Line.enumber }}
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.vnl2l3Line &&
                            e.vnl2l3Line.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.vnl2l3Line.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 === e.vnl2l3Line.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.vnl2l3Line.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{ e.vnl2l3Line.enumber }}
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- マルチクラウド接続 -->
                      <template
                        v-if="
                          selectedUnit.unit === 'MULTICLOUD_CLOUD' ||
                          selectedUnit.unit === 'MULTICLOUD_CLOUD_NUMBER' ||
                          selectedUnit.unit === 'MULTICLOUD_CLOUD_ENUMBER'
                        "
                      >
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.cloudLine &&
                            e.cloudLine.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              <template
                                v-if="selectedUnit.unit === 'MULTICLOUD_CLOUD'"
                              >
                                {{ e.cloudLine.enumber }}<br />
                                {{
                                  formatCloudServiceMenu(
                                    e.cloudLine.cloudServiceMenu
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="
                                  selectedUnit.unit ===
                                  'MULTICLOUD_CLOUD_NUMBER'
                                "
                              >
                                {{ e.cloudLine.wnumberAct }}<br />
                                {{ e.cloudLine.wnumberSby }}
                              </template>
                              <template v-else>
                                {{ e.cloudLine.enumber }}
                              </template>
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.cloudLine &&
                            e.cloudLine.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.cloudLine.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 === e.cloudLine.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.cloudLine.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                <template
                                  v-if="
                                    selectedUnit.unit === 'MULTICLOUD_CLOUD'
                                  "
                                >
                                  {{ e.cloudLine.enumber }}<br />
                                  {{
                                    formatCloudServiceMenu(
                                      e.cloudLine.cloudServiceMenu
                                    )
                                  }}
                                </template>
                                <template
                                  v-else-if="
                                    selectedUnit.unit ===
                                    'MULTICLOUD_CLOUD_NUMBER'
                                  "
                                >
                                  {{ e.cloudLine.wnumberAct }}<br />
                                  {{ e.cloudLine.wnumberSby }}
                                </template>
                                <template v-else>
                                  {{ e.cloudLine.enumber }}
                                </template>
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>
                                <template
                                  v-if="
                                    (limit.upperLimitItemName ===
                                      'VNコネクト(ホスト型接続)' ||
                                      limit.upperLimitItemName ===
                                        '契約上限値') &&
                                    limit.upperLimit >= 1000 &&
                                    limit.unit === 'Mbps'
                                  "
                                >
                                  {{ limit.upperLimit / 1000 }} Gbps
                                </template>
                                <template v-else>
                                  {{ limit.upperLimit }} {{ limit.unit }}
                                </template>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- SASEゲートウェイ / タイプ -->
                      <template v-if="selectedUnit.unit === 'SASEGATEWAY_TYPE'">
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.saseGateway &&
                            e.saseGateway.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{
                                $filter.enumTo(
                                  e.saseGateway.saseGatewayServiceType,
                                  "saseGatewayServiceType"
                                )
                              }}
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.saseGateway &&
                            e.saseGateway.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.saseGateway.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 ===
                                  e.saseGateway.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.saseGateway.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{
                                  $filter.enumTo(
                                    e.saseGateway.saseGatewayServiceType,
                                    "saseGatewayServiceType"
                                  )
                                }}
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template
                                  v-else-if="
                                    (limit.upperLimitItemName ===
                                      'VNコネクト帯域値' ||
                                      limit.upperLimitItemName ===
                                        'SASEゲートウェイ接続先合計帯域値') &&
                                    limit.current >= 1000 &&
                                    limit.unit === 'Mbps'
                                  "
                                >
                                  {{ limit.current / 1000 }} Gbps
                                </template>
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>
                                <template
                                  v-if="
                                    (limit.upperLimitItemName ===
                                      'VNコネクト帯域値' ||
                                      limit.upperLimitItemName ===
                                        'SASEゲートウェイ接続先合計帯域値') &&
                                    limit.upperLimit >= 1000 &&
                                    limit.unit === 'Mbps'
                                  "
                                >
                                  {{ limit.upperLimit / 1000 }} Gbps
                                </template>
                                <template v-else>
                                  {{ limit.upperLimit }} {{ limit.unit }}
                                </template>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>

                      <!-- SASEゲートウェイ / W番号 / タイプ -->
                      <template
                        v-if="selectedUnit.unit === 'SASEGATEWAY_NUMBER_TYPE'"
                      >
                        <!-- 404でデータなし時の表示-->
                        <template
                          v-if="
                            e.saseGateway &&
                            e.saseGateway.upperLimitList.length === 0
                          "
                        >
                          <tr class="border-bottom-double">
                            <td
                              :class="{
                                'border-bottom-double-td':
                                  i1 + 1 !== upperLimit2.items.length,
                              }"
                            >
                              {{ e.saseGateway.wnumberAct }} /
                              {{ e.saseGateway.wnumberSby }}
                            </td>
                            <td colspan="3" class="text-center">
                              {{ $filter.message("no_data") }}
                            </td>
                          </tr>
                        </template>
                        <template
                          v-if="
                            e.saseGateway &&
                            e.saseGateway.upperLimitList.length !== 0
                          "
                        >
                          <template
                            v-for="(limit, i2) in e.saseGateway.upperLimitList"
                            :key="`${i1}_${i2}`"
                          >
                            <tr
                              :class="{
                                'border-bottom-double':
                                  i2 + 1 ===
                                  e.saseGateway.upperLimitList.length,
                              }"
                            >
                              <td
                                v-if="i2 === 0"
                                :rowspan="e.saseGateway.upperLimitList.length"
                                :class="{
                                  'border-bottom-double-td':
                                    i1 + 1 !== upperLimit2.items.length,
                                }"
                              >
                                {{ e.saseGateway.wnumberAct }} /
                                {{ e.saseGateway.wnumberSby }}
                              </td>
                              <td>{{ limit.upperLimitItemName }}</td>
                              <td>
                                <template v-if="limit.current === null"
                                  >-</template
                                >
                                <template v-else
                                  >{{ limit.current }}
                                  {{ limit.unit }}</template
                                >
                              </td>
                              <td>{{ limit.upperLimit }} {{ limit.unit }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </template>
                  </tbody>
                </v-table>
              </template>
            </v-form>
          </validation-observer>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import type {
  QueryParamEntity,
  SaseGatewayEntity,
  UpperLimitEntity,
  UpperLimitLineGetEntity,
  UpperLimitLineSearchGetEntity,
  UpperLimitSearchAccessLine,
  UpperLimitSearchCloud,
  UpperLimitSearchInternet,
  UpperLimitSearchPfgw,
  UpperLimitSearchVn,
  UpperLimitSearchVnl2l3,
} from "@/apis/UpperLimitApi";
import { mapState } from "vuex";
import MultiSelectTag from "@/components/MultiSelectTag.vue";
import type { ContractAppliances, ContractInfo } from "@/apis/ContractApi";
import { ApiNotFoundError } from "@/error/errors";

export default defineComponent({
  name: "ContractSettingList",
  components: {
    MultiSelectTag,
  },
  data() {
    return {
      /** 上限値項目選択肢 */
      // prettier-ignore
      units: [
        { unit: "CONTRACT_NUMBER",            l1: "契約", l2: "V番号" },
        { unit: "ACCESS_NUMBER",              l1: "アクセス回線", l2: "E番号"},
        { unit: "ACCESS_NUMBER_VLAN",         l1: "アクセス回線", l2: "E番号", l3: "VLAN"},
        { unit: "APPLIANCE_PF",               l1: "アプライアンス", l2: undefined, l3: "パケットフィルタリング"},
        { unit: "APPLIANCE_INTRANET",         l1: "アプライアンス", l2: "インターネットType1", l3: "イントラネットFW"},
        { unit: "APPLIANCE_NUMBER_INTERNET",  l1: "アプライアンス", l2: "インターネット(E番号/W番号)", l3: "インターネットFW"},
        { unit: "APPLIANCE_NUMBER_UTM",       l1: "アプライアンス", l2: "インターネット(E番号/W番号)", l3: "UTM"},
        { unit: "APPLIANCE_NUMBER_NAT",       l1: "アプライアンス", l2: "インターネット(E番号/W番号)", l3: "NAT"},
        { unit: "PFGW_NUMBER",                l1: "PFGW(イントラ)", l2: "E番号(Act/Sby)"},
        { unit: "VN_NUMBER",                  l1: "VNコネクト", l2: "W番号"},
        { unit: "VNL2L3_NUMBER",              l1: "VN L2/L3コネクト", l2: "E番号"},
        { unit: "MULTICLOUD_CLOUD",           l1: "マルチクラウド", l2: "クラウド"},
        { unit: "MULTICLOUD_CLOUD_NUMBER",    l1: "マルチクラウド", l2: "クラウド", l3: "W番号"},
        { unit: "MULTICLOUD_CLOUD_ENUMBER",   l1: "マルチクラウド", l2: "E番号"},
        { unit: "INTERNET4_NUMBER",           l1: "インターネットType4", l2: "W番号"},
        { unit: "SASEGATEWAY_TYPE",      l1: "SASEゲートウェイ", l2: "タイプ" },
        { unit: "SASEGATEWAY_NUMBER_TYPE",    l1: "SASEゲートウェイ", l2: "W番号", l3: "タイプ"},
      ] as { unit: UpperUnit; l1: string; l2?: string, l3?: string }[],
      selectedUnit: null as null | { unit: UpperUnit },
      selectedLineNumbers: [] as { data: unknown }[],
      upperLimitSearch: null as null | UpperLimitLineSearchGetEntity,
      /** 契約 - V番号用 */
      upperLimit1: {
        fields: [
          { key: "upperLimitItemName", title: "設定項目", width: "280px" },
          { key: "current", title: "現在設定数", width: "200px" },
          { key: "upperLimit", title: "上限値", width: "200px" },
        ],
        items: null as null | UpperLimitEntity[],
      },
      /** 契約 - V番号 以外用 */
      upperLimit2: {
        items: null as null | UpperLimitLineGetEntity[],
      },
      isLoaded: false,
    };
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
      contractAppliances: "contractAppliances",
    }),
    /** 表示条件に従いフィルタリングされた上限値項目 */
    displayUnits(): {
      unit: UpperUnit;
      l1: string;
      l2?: string;
      l3?: string;
    }[] {
      return this.units.filter((e) => {
        switch (e.unit) {
          case "ACCESS_NUMBER":
          case "ACCESS_NUMBER_VLAN":
            return this.isShowAccess;
          case "APPLIANCE_PF":
            return this.isShowPacketFiltering;
          case "APPLIANCE_INTRANET":
            return this.isShowIntranetFW;
          case "APPLIANCE_NUMBER_INTERNET":
            return this.isShowInternetFW;
          case "APPLIANCE_NUMBER_UTM":
            return this.isShowInternetUTM;
          case "APPLIANCE_NUMBER_NAT":
            return this.isShowInternetFW || this.isShowInternetUTM;
          case "PFGW_NUMBER":
            return this.isShowPFGW;
          case "VNL2L3_NUMBER":
            return this.isShowVNL2L3;
          case "MULTICLOUD_CLOUD":
          case "MULTICLOUD_CLOUD_NUMBER":
          case "MULTICLOUD_CLOUD_ENUMBER":
            return this.isShowMulticloud;
          case "INTERNET4_NUMBER":
            return this.isShowInternetType4;
          default:
            return true;
        }
      });
    },
    /**
     * 回線番号の選択肢.
     * 選択された上限値項目によって表示方法や導出元が異なる
     */
    lineNumberOptions(): {
      labels: {
        item1: string;
        item2?: string;
        item3?: string;
      };
      values: {
        index: number;
        data: unknown;
        label1: string;
        label2?: string | number;
        label3?: string;
      }[];
    }[] {
      if (!this.selectedUnit || !this.upperLimitSearch) {
        return [];
      }

      switch (this.selectedUnit.unit) {
        case "CONTRACT_NUMBER":
        case "APPLIANCE_PF":
        case "APPLIANCE_INTRANET":
          throw new Error(`unexpected unit`);
        case "ACCESS_NUMBER":
          return [
            {
              labels: { item1: "回線番号" },
              values: this.upperLimitSearch.accessLineList.map((e, i) => ({
                index: i,
                data: e,
                label1: e.enumber,
              })),
            },
          ];
        case "ACCESS_NUMBER_VLAN":
          return [
            {
              labels: { item1: "回線番号", item2: "VLAN" },
              values: this.upperLimitSearch.accessLineList
                .flatMap((e) =>
                  e.siteList.map((site) => ({ enumber: e.enumber, ...site }))
                )
                .map((e, i) => ({
                  index: i,
                  data: e,
                  label1: e.enumber,
                  label2:
                    e.vlanIdType === "SPECIFIED"
                      ? e.vlanId!
                      : e.vlanIdType === "OTHER"
                        ? "Other"
                        : "Untag",
                })),
            },
          ];
        case "APPLIANCE_NUMBER_INTERNET":
        case "APPLIANCE_NUMBER_UTM":
        case "APPLIANCE_NUMBER_NAT":
          return [
            {
              labels: { item1: "E番号/W番号" },
              values: this.upperLimitSearch.internetLineList
                .map((e, i) => ({
                  index: i,
                  data: e,
                  label1: e.type1
                    ? e.type1.enumberMainAct
                    : e.type4!.wnumberMainAct,
                }))
                .filter((e) => {
                  switch (this.selectedUnit!.unit) {
                    case "APPLIANCE_NUMBER_INTERNET":
                      return e.data.applianceType === "INTERNET_FW";
                    case "APPLIANCE_NUMBER_UTM":
                      return e.data.applianceType === "UTM";
                    case "APPLIANCE_NUMBER_NAT":
                      return e.data.applianceType === "NAT";
                    case "APPLIANCE_PF":
                    case "APPLIANCE_INTRANET":
                    default:
                      throw new Error(
                        `unknown unit. ${this.selectedUnit!.unit}`
                      );
                  }
                }),
            },
          ];
        case "PFGW_NUMBER":
          return [
            {
              labels: { item1: "E番号(Act)", item2: "E番号(Sby)" },
              values: this.upperLimitSearch.pfgwLineList.map((e, i) => ({
                index: i,
                data: e,
                label1: e.enumberAct,
                label2: e.enumberSby,
              })),
            },
          ];
        case "VN_NUMBER":
          return [
            {
              labels: { item1: "W番号" },
              values: this.upperLimitSearch.vnLineList.map((e, i) => ({
                index: i,
                data: e,
                label1: e.wnumber,
              })),
            },
          ];
        case "VNL2L3_NUMBER":
          return [
            {
              labels: { item1: "E番号" },
              values: this.upperLimitSearch.vnl2l3LineList.map((e, i) => ({
                index: i,
                data: e,
                label1: e.enumber,
              })),
            },
          ];
        case "MULTICLOUD_CLOUD":
          return [
            {
              labels: { item1: "E番号", item2: "クラウド" },
              values: this.upperLimitSearch.cloudLineList.map((e, i) => ({
                index: i,
                data: e,
                label1: e.enumber,
                label2: this.formatCloudServiceMenu(e.cloudServiceMenu),
              })),
            },
          ];
        case "MULTICLOUD_CLOUD_NUMBER":
          return [
            {
              labels: { item1: "E番号", item2: "クラウド", item3: "W番号" },
              values: this.upperLimitSearch.cloudLineList
                .flatMap((e) =>
                  e.vnConnectList.map((vn) => ({
                    cloudLineSeq: e.cloudLineSeq,
                    enumber: e.enumber,
                    cloudServiceMenu: e.cloudServiceMenu,
                    ...vn,
                  }))
                )
                .map((e, i) => ({
                  index: i,
                  data: e,
                  label1: e.enumber,
                  label2: this.formatCloudServiceMenu(e.cloudServiceMenu),
                  label3: e.wnumberAct,
                })),
            },
          ];
        case "MULTICLOUD_CLOUD_ENUMBER": {
          const set = new Set(
            this.upperLimitSearch.cloudLineList.map((e) => e.enumber)
          );
          const uniqueENumber = [...set];

          return [
            {
              labels: { item1: "E番号" },
              values: uniqueENumber.map((e, i) => ({
                index: i,
                data: { enumber: e },
                label1: e,
              })),
            },
          ];
        }
        case "INTERNET4_NUMBER":
          return [
            {
              labels: { item1: "W番号" },
              values: this.upperLimitSearch.internetType4List.map((e, i) => ({
                index: i,
                data: e,
                label1: e.wnumberMainAct,
              })),
            },
          ];
        case "SASEGATEWAY_TYPE": {
          // 重複するタイプを削除
          const uniqueTypes = this.upperLimitSearch.saseGatewayList.uniq(
            (e) => e.saseGatewayServiceType
          );
          return [
            {
              labels: { item1: "タイプ" },
              values: uniqueTypes.map((e, i) => ({
                index: i,
                data: e,
                label1: this.$filter.enumTo(
                  e.saseGatewayServiceType,
                  "saseGatewayServiceType"
                ),
              })),
            },
          ];
        }
        case "SASEGATEWAY_NUMBER_TYPE":
          return [
            {
              labels: { item1: "W番号(Act/Sby)", item2: "タイプ" },
              values: this.upperLimitSearch.saseGatewayList
                .flatMap((e) =>
                  e.vnConnectList.map((vn) => ({
                    saseGatewayServiceType: e.saseGatewayServiceType,
                    ...vn,
                  }))
                )
                .map((e, i) => ({
                  index: i,
                  data: e,
                  label1: `${e.wnumberAct} / ${e.wnumberSby}`,
                  label2: this.$filter.enumTo(
                    e.saseGatewayServiceType,
                    "saseGatewayServiceType"
                  ),
                })),
            },
          ];
        default:
          throw new Error(`unknown unit. ${this.selectedUnit.unit}`);
      }
    },
    /** true: 上限値単位「アクセス回線」を表示, false: 非表示 */
    isShowAccess(): boolean {
      return this.contractInfo.contractList.some(
        (e: ContractInfo["contractList"][0]) =>
          e.accessType !== "PLATFORM_GATEWAY" &&
          e.accessType !== "VN_L2L3_CONNECT"
      );
    },
    /** true: 上限値単位「アプライアンス ... パケットフィルタリング」を表示, false: 非表示 */
    isShowPacketFiltering(): boolean {
      return this.contractSummary.isPacketFiltering;
    },
    /** true: 上限値単位「アプライアンス ... インターネットFW」を表示, false: 非表示 */
    isShowInternetFW(): boolean {
      return (
        this.contractAppliances.applianceInfoList.some(
          (e: ContractAppliances["applianceInfoList"][0]) =>
            e.internetType === "TYPE1" || e.internetType === "TYPE4"
        ) &&
        this.contractAppliances.applianceInfoList.some(
          (e: ContractAppliances["applianceInfoList"][0]) =>
            e.applianceType === "IFW_BE" ||
            e.applianceType === "IFW_CONTRACT_BAND"
        )
      );
    },
    /** true: 上限値単位「アプライアンス ... UTM」を表示, false: 非表示 */
    isShowInternetUTM(): boolean {
      return (
        this.contractAppliances.applianceInfoList.some(
          (e: ContractAppliances["applianceInfoList"][0]) =>
            e.internetType === "TYPE1" || e.internetType === "TYPE4"
        ) &&
        this.contractAppliances.applianceInfoList.some(
          (e: ContractAppliances["applianceInfoList"][0]) =>
            e.applianceType === "UTM_BE" ||
            e.applianceType === "UTM_CONTRACT_BAND"
        )
      );
    },
    /** true: 上限値単位「アプライアンス ... イントラネットFW」を表示, false: 非表示 */
    isShowIntranetFW(): boolean {
      return this.contractAppliances.applianceInfoList.some(
        (e: ContractAppliances["applianceInfoList"][0]) =>
          e.internetType === "INTRANET"
      );
    },
    /** true: 上限値単位「PFGW(イントラ)」を表示, false: 非表示 */
    isShowPFGW(): boolean {
      return this.contractInfo.contractList.some(
        (e: ContractInfo["contractList"][0]) =>
          e.accessType === "PLATFORM_GATEWAY"
      );
    },
    /** true: 上限値単位「VN L2/L3コネクト」を表示, false: 非表示 */
    isShowVNL2L3(): boolean {
      return this.contractInfo.contractList.some(
        (e: ContractInfo["contractList"][0]) =>
          e.accessType === "VN_L2L3_CONNECT"
      );
    },
    /** true: 上限値単位「マルチクラウド」を表示, false: 非表示 */
    isShowMulticloud(): boolean {
      return this.contractInfo.contractList.some(
        (e: ContractInfo["contractList"][0]) =>
          e.accessType === "MULTI_CLOUD_GW"
      );
    },
    /** true: 上限値単位「インターネットType4」を表示, false: 非表示 */
    isShowInternetType4(): boolean {
      return this.contractAppliances.applianceInfoList.some(
        (e: ContractAppliances["applianceInfoList"][0]) =>
          e.internetType === "TYPE4"
      );
    },
  },
  watch: {
    /**
     * 上限値項目が変更された際に各種変数を初期化し必要な情報を再取得する.
     * 契約-V番号: 契約単位の設定上限値を取得
     * その他: 回線の選択肢を表示するために回線情報を取得
     */
    async selectedUnit(newValue: null | { unit: UpperUnit }) {
      // 各種情報を初期化
      this.selectedLineNumbers = [];
      this.upperLimit1.items = null;
      this.upperLimit2.items = null;
      this.upperLimitSearch = null;

      if (!newValue) {
        return;
      }

      switch (newValue.unit) {
        case "CONTRACT_NUMBER":
          try {
            this.upperLimit1.items = (
              await this.$api.upperLimit.getUpperLimit()
            ).upperLimitList;
          } catch (e) {
            // 回線によっては上限値がそもそも存在しない場合がある
            // その際は404が返ってくるため上限値0件として表示する
            if (e instanceof ApiNotFoundError) {
              this.upperLimit1.items = [];
              return;
            }
            throw e;
          }
          break;
        case "ACCESS_NUMBER":
        case "ACCESS_NUMBER_VLAN":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("ACCESS");
          break;
        case "APPLIANCE_PF":
          try {
            this.upperLimit2.items = [
              await this.$api.upperLimit.getUpperLimitLine({
                upperLimitLineManageUnit: "APPLIANCE",
                applianceType: "PACKET_FILTERING",
              }),
            ];
          } catch (e) {
            // 回線によっては上限値がそもそも存在しない場合がある
            // その際は404が返ってくるため上限値0件として表示する
            if (e instanceof ApiNotFoundError) {
              this.upperLimit2.items = [
                {
                  accessLine: null,
                  cloudLine: null,
                  pfgwLine: null,
                  vnConnect: null,
                  vnl2l3Line: null,
                  internetLine: {
                    applianceType: "PACKET_FILTERING",
                    type1: null,
                    type4: null,
                    upperLimitList: [],
                  },
                  saseGateway: null,
                },
              ];
              return;
            }
            throw e;
          }
          break;
        case "APPLIANCE_INTRANET":
          try {
            this.upperLimit2.items = [
              await this.$api.upperLimit.getUpperLimitLine({
                upperLimitLineManageUnit: "APPLIANCE",
                applianceType: "INTRANET_FW",
              }),
            ];
          } catch (e) {
            // 回線によっては上限値がそもそも存在しない場合がある
            // その際は404が返ってくるため上限値0件として表示する
            if (e instanceof ApiNotFoundError) {
              this.upperLimit2.items = [
                {
                  accessLine: null,
                  cloudLine: null,
                  pfgwLine: null,
                  vnConnect: null,
                  vnl2l3Line: null,
                  internetLine: {
                    applianceType: "INTRANET_FW",
                    type1: null,
                    type4: null,
                    upperLimitList: [],
                  },
                  saseGateway: null,
                },
              ];
              return;
            }
            throw e;
          }
          break;
        case "APPLIANCE_NUMBER_INTERNET":
        case "APPLIANCE_NUMBER_UTM":
        case "APPLIANCE_NUMBER_NAT":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("APPLIANCE");
          break;
        case "PFGW_NUMBER":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("PFGW");
          break;
        case "VN_NUMBER":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("VN");
          break;
        case "VNL2L3_NUMBER":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("VNL2L3");
          break;
        case "MULTICLOUD_CLOUD":
        case "MULTICLOUD_CLOUD_NUMBER":
        case "MULTICLOUD_CLOUD_ENUMBER":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("MULTI_CLOUD");
          break;
        case "INTERNET4_NUMBER":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch(
              "INTERNET_TYPE4"
            );
          break;
        case "SASEGATEWAY_TYPE":
        case "SASEGATEWAY_NUMBER_TYPE":
          this.upperLimitSearch =
            await this.$api.upperLimit.getUpperLimitLineSearch("SASE_GATEWAY");
          break;
        default:
          throw new Error(`unknown unit. ${newValue.unit}`);
      }
    },
  },
  async mounted() {
    this.isLoaded = true;
  },
  methods: {
    /** リセットボタン */
    reset() {
      this.selectedLineNumbers = [];
    },
    /** 上限値表示 */
    async submit() {
      this.upperLimit2.items = null;

      const limits = ((): Promise<UpperLimitLineGetEntity>[] => {
        switch (this.selectedUnit!.unit) {
          case "CONTRACT_NUMBER":
          case "APPLIANCE_PF":
          case "APPLIANCE_INTRANET":
            throw new Error(`unexpected unit`);
          case "ACCESS_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchAccessLine;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "ACCESS",
                  enumber: data.enumber,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      accessLine: {
                        enumber: data.enumber,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "ACCESS_NUMBER_VLAN":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as {
                enumber: string;
              } & UpperLimitSearchAccessLine["siteList"][0];
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "ACCESS",
                  enumber: data.enumber,
                  vlanIdType: data.vlanIdType,
                  vlanId: data.vlanId!,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      accessLine: {
                        enumber: data.enumber,
                        vlanId: data.vlanId,
                        vlanIdType: data.vlanIdType,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "APPLIANCE_NUMBER_INTERNET":
          case "APPLIANCE_NUMBER_UTM":
          case "APPLIANCE_NUMBER_NAT":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchInternet;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "APPLIANCE",
                  applianceType: ((): QueryParamEntity["applianceType"] => {
                    switch (this.selectedUnit!.unit) {
                      case "APPLIANCE_NUMBER_INTERNET":
                        return "INTERNET_FW";
                      case "APPLIANCE_NUMBER_UTM":
                        return "UTM";
                      case "APPLIANCE_NUMBER_NAT":
                        return "NAT";
                    }
                  })(),
                  enumber: data.type1?.enumberMainAct ?? undefined,
                  wnumber: data.type4?.wnumberMainAct ?? undefined,
                  type4Id: data.type4?.type4Id ?? undefined,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      internetLine: {
                        applianceType: data.applianceType,
                        type1: data.type1,
                        type4: data.type4,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "PFGW_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchPfgw;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "PFGW",
                  enumber: data.enumberAct,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      pfgwLine: {
                        enumberAct: data.enumberAct,
                        enumberSby: data.enumberSby,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "VN_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchVn;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "VN",
                  wnumber: data.wnumber,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      vnConnect: {
                        wnumber: data.wnumber,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "VNL2L3_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchVnl2l3;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "VNL2L3",
                  enumber: data.enumber,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      vnl2l3Line: {
                        enumber: data.enumber,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "MULTICLOUD_CLOUD":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchCloud;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "MULTI_CLOUD",
                  cloudLineSeq: data.cloudLineSeq,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      cloudLine: {
                        enumber: data.enumber,
                        cloudServiceMenu: data.cloudServiceMenu,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "MULTICLOUD_CLOUD_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as {
                cloudLineSeq: string;
              } & UpperLimitSearchCloud["vnConnectList"][0];
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "MULTI_CLOUD",
                  cloudLineSeq: data.cloudLineSeq,
                  wnumber: data.wnumberAct,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      cloudLine: {
                        wnumberAct: data.wnumberAct,
                        wnumberSby: data.wnumberSby,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "MULTICLOUD_CLOUD_ENUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as UpperLimitSearchCloud;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "MULTI_CLOUD",
                  enumber: data.enumber,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      cloudLine: {
                        enumber: data.enumber,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "INTERNET4_NUMBER":
            return this.selectedLineNumbers.map((e) => {
              const data =
                e.data as UpperLimitLineSearchGetEntity["internetType4List"][0];
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "INTERNET_TYPE4",
                  type4Id: data.type4Id,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      internetLine: {
                        type4: { ...data },
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "SASEGATEWAY_TYPE":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as Pick<
                SaseGatewayEntity,
                "saseGatewayServiceType" | "vnConnectList"
              >;
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "SASE_GATEWAY",
                  saseGatewayServiceType: data.saseGatewayServiceType,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      saseGateway: {
                        saseGatewayServiceType: data.saseGatewayServiceType,
                        wnumberAct: null,
                        wnumberSby: null,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
          case "SASEGATEWAY_NUMBER_TYPE":
            return this.selectedLineNumbers.map((e) => {
              const data = e.data as {
                saseGatewayServiceType: SaseGatewayEntity["saseGatewayServiceType"];
                wnumberAct: string;
                wnumberSby: string;
              };
              return this.$api.upperLimit
                .getUpperLimitLine({
                  upperLimitLineManageUnit: "SASE_GATEWAY",
                  wnumber: data.wnumberAct,
                  saseGatewayServiceType: data.saseGatewayServiceType,
                })
                .catch((error: Error) => {
                  if (error instanceof ApiNotFoundError) {
                    return {
                      saseGateway: {
                        saseGatewayServiceType: data.saseGatewayServiceType,
                        wnumberAct: data.wnumberAct,
                        wnumberSby: data.wnumberSby,
                        upperLimitList: [] as UpperLimitEntity[],
                      },
                    } as UpperLimitLineGetEntity;
                  }
                  throw error;
                });
            });
        }
      })();
      this.upperLimit2.items = await Promise.all(limits);
    },

    /** 上限値項目ラベル */
    labelUnit(e: { l1: string; l2?: string; l3?: string }) {
      if (e.l2 && e.l3) {
        return `${e.l1} / ${e.l2} / ${e.l3}`;
      } else if (e.l2 && !e.l3) {
        return `${e.l1} / ${e.l2}`;
      } else if (!e.l2 && e.l3) {
        return `${e.l1} / - / ${e.l3}`;
      } else {
        return e.l1;
      }
    },
    /** 回線番号項目ラベル（検索用） */
    labelLineNumber(e: { label1: string; label2?: string; label3?: string }) {
      return `${e.label1} ${e.label2 ?? ""} ${e.label3 ?? ""}`;
    },
    /**
     * クラウドサービスメニューの表示名を変換する
     * @param cloudServiceMenu クラウドサービスメニューコード
     * @returns 表示用のサービス名
     */
    formatCloudServiceMenu(cloudServiceMenu: string) {
      switch (cloudServiceMenu) {
        case "SFDC":
          return "Salesforce";
        case "KCPS3":
          return "KCPS";
        case "KDDI_GPU_CLOUD":
          return "KDDI GPU Cloud";
        default:
          return cloudServiceMenu;
      }
    },
  },
});

/**
 * 上限値項目種別
 * CONTRACT_NUMBER:           契約 / V番号
 * ACCESS_NUMBER:             アクセス回線 / E番号
 * ACCESS_NUMBER_VLAN:        アクセス回線 / E番号 / VLAN
 * APPLIANCE_PF:              アプライアンス / - / パケットフィルタリング
 * APPLIANCE_INTRANET:        アプライアンス / インターネットType1 / イントラネットFW
 * APPLIANCE_NUMBER_INTERNET: アプライアンス / インターネット(E番号/W番号) / インターネットFW
 * APPLIANCE_NUMBER_UTM:      アプライアンス / インターネット(E番号/W番号) / UTM
 * APPLIANCE_NUMBER_NAT:      アプライアンス / インターネット(E番号/W番号) / NAT
 * PFGW_NUMBER:               PFGW（イントラ） / E番号（Act/Sby）
 * VN_NUMBER:                 VNコネクト / W番号
 * VNL2L3_NUMBER:             VN L2/L3コネクト / E番号
 * MULTICLOUD_CLOUD:          マルチクラウド / クラウド
 * MULTICLOUD_CLOUD_NUMBER:   マルチクラウド / クラウド / W番号
 * MULTICLOUD_CLOUD_ENUMBER:  マルチクラウド / E番号
 * INTERNET4_NUMBER:          インターネットType4 / W番号
 * SASEGATEWAY_TYPE:     SASEゲートウェイ / タイプ
 * SASEGATEWAY_NUMBER_TYPE:         SASEゲートウェイ / W番号 / タイプ
 */
type UpperUnit =
  | "CONTRACT_NUMBER"
  | "ACCESS_NUMBER"
  | "ACCESS_NUMBER_VLAN"
  | "APPLIANCE_PF"
  | "APPLIANCE_INTRANET"
  | "APPLIANCE_NUMBER_INTERNET"
  | "APPLIANCE_NUMBER_UTM"
  | "APPLIANCE_NUMBER_NAT"
  | "PFGW_NUMBER"
  | "VN_NUMBER"
  | "VNL2L3_NUMBER"
  | "MULTICLOUD_CLOUD"
  | "MULTICLOUD_CLOUD_NUMBER"
  | "MULTICLOUD_CLOUD_ENUMBER"
  | "INTERNET4_NUMBER"
  | "SASEGATEWAY_TYPE"
  | "SASEGATEWAY_NUMBER_TYPE";
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid #dee2e6;
  th {
    background-color: #e9ecef;
  }
}

.content {
  overflow: initial;
}

/* 最終行以外に適用 */
table tr:not(:last-child).border-bottom-double td {
  border-bottom: 3px double #b6b6be !important;
}

/* <td>に直接適用 */
.border-bottom-double-td {
  border-bottom: 3px double #b6b6be !important;
}
</style>
